import {useParams} from "react-router-dom";
import i18next from "i18next";

export const useTranslation = () => {
  try {
    const { lang } = useParams();
    return i18next.getResourceBundle(lang, "");
  } catch (e) {
    console.error(e);
  }
};
